<div class="rowContainer {{typeOfList}} color_{{IndexOdd}} {{ getRowStatus() }}">
  <div class="matchTime">
    <p class="MatchGroupDate" *ngIf="fixtureItem?.MatchGroupDate != '' ">{{fixtureItem?.MatchGroupDate}}</p>
    <p class="matchTimep" *ngIf="fixtureItem?.MatchTime != ''">{{fixtureItem?.MatchTime}}</p>
    <p *ngIf="fixtureItem.TimeStatu == 3 || fixtureItem.TimeStatu == 5"
       style="color:#ffffff;font-size:20px">{{fixtureItem?.TimeStatuColor}}</p>
    <p  class="matchTimep" *ngIf="(sportEnum == 5 || sportEnum == 20 || sportEnum == 6 || sportEnum == 3 || sportEnum == 2) && typeOfList == 'live'"
        style="font-size:20px">{{fixtureItem?.TimeStatuColor}}</p>
  </div>
  <div class="teamsContainer">

    <div class="upperArea">
      {{fixtureItem?.TournamentNameFull}}
    </div>

    <div class="lowerArea">
      <div class="homeTeam">
        <!--<span class="u21" *ngIf="fixtureItem?.U21 != ''">{{fixtureItem?.U21}}</span>-->
        <span class="teamName {{fixtureItem?.homegoalcss}}">{{fixtureItem?.HomeTeam}}</span>

        <span class="matchServer" *ngIf="sportEnum == 5 && fixtureItem.MatchServer == 1"></span>

<!--        <span *ngIf="this.tournamentsService._cardList && this.getCard(fixtureItem.MatchId,true) !='0'" class="redcard"-->
<!--              style="text-align:center">{{this.getCard(fixtureItem.MatchId, true)}}</span>-->

        <span *ngIf="fixtureItem?.RedCardHomeTeam && fixtureItem?.RedCardHomeTeam != 0" class="redcard"
              style="text-align:center">
          {{fixtureItem?.RedCardHomeTeam}}
        </span>

        <ng-container *ngIf="fixtureItem?.BetReasonId != 0">
          <div class="betstopreason"
               *ngIf="fixtureItem?.BetReasonId == 1 || fixtureItem?.BetReasonId == 2 ||fixtureItem?.BetReasonId == 4 ||
               fixtureItem?.BetReasonId == 6 || fixtureItem?.BetReasonId == 9 || fixtureItem?.BetReasonId == 20 ||
               fixtureItem?.BetReasonId == 88 || fixtureItem?.BetReasonId == 18 || fixtureItem?.BetReasonId == 83"
               [ngClass]="{
               'red' : fixtureItem?.BetReasonId == 2 || fixtureItem?.BetReasonId == 6 || fixtureItem?.BetReasonId ==
               20 || fixtureItem?.BetReasonId == 88 || fixtureItem?.BetReasonId == 18 || fixtureItem?.BetReasonId == 83,
               'orange' : fixtureItem?.BetReasonId == 1 || fixtureItem?.BetReasonId == 4 || fixtureItem?.BetReasonId
               == 9}">
            {{fixtureItem?.BetReason}}
          </div>
        </ng-container>


      </div>
      <div class="awayTeam">
        <!--<span class="u21" *ngIf="fixtureItem?.U21 != ''">{{fixtureItem?.U21}}</span>-->
        <span class="teamName {{fixtureItem?.awaygoalcss}}">{{fixtureItem?.AwayTeam}}</span>

        <span class="matchServer" *ngIf="sportEnum == 5 && fixtureItem.MatchServer == 2"></span>

<!--        <span *ngIf="this.tournamentsService._cardList && this.getCard(fixtureItem.MatchId,false) !='0'" class="redcard"-->
<!--              style="text-align:center">{{this.getCard(fixtureItem.MatchId, false)}}</span>-->

        <span *ngIf="fixtureItem?.RedCardAwayTeam && fixtureItem?.RedCardAwayTeam != 0" class="redcard"
              style="text-align:center">
          {{fixtureItem?.RedCardAwayTeam}}
        </span>

        <ng-container *ngIf="fixtureItem?.BetReasonId != 0">
          <div class="betstopreason"
               *ngIf="fixtureItem?.BetReasonId == 5 || fixtureItem?.BetReasonId == 7 ||
           fixtureItem?.BetReasonId == 10 || fixtureItem?.BetReasonId == 21 || fixtureItem?.BetReasonId == 89 ||
           fixtureItem?.BetReasonId == 19"
               [ngClass]="{
               'red' : fixtureItem?.BetReasonId == 7 || fixtureItem?.BetReasonId == 21 || fixtureItem?.BetReasonId ==
                89 || fixtureItem?.BetReasonId == 19,
               'orange' : fixtureItem?.BetReasonId == 5 || fixtureItem?.BetReasonId == 10}">
            {{fixtureItem?.BetReason}}
          </div>
        </ng-container>

      </div>

    </div>
  </div>
  <div class="multipleRow">
    <div class="firstRow">
      <div class="statusArea">
        <button *ngIf="typeOfList === 'live' && this.livetracker " class="ui icon button iconStatisticButton" (click)="OpenLiveTrackerModal(fixtureItem)"><span><i class="white tv large icon" style="color: white"></i></span></button>

        <button *ngIf="typeOfList != 'live' && this.activeDomain == 'wett' " class="ui icon button iconStatisticButton" (click)="OpenStandingsModal(fixtureItem)"><span><i class="white signal large icon" style="color: white"></i></span></button>
        <button class="ui icon green button {{fixtureItem.IsLive === 1 ? 'show' : 'hide' }}"><span>L</span></button>
        <scoreView *ngIf="typeOfList === 'live'" [fixtureItem]="fixtureItem" [sportTypeEnum]="sportEnum"></scoreView>
      </div>
      <div class="nine wide divOdd" style="text-align:center">
        <div class="oddGroup" *ngIf="!liveActionView(fixtureItem, isScoreBox)">
          <oddView [typeOfList]=typeOfList
                   [_data]="oddValues[0]"
                   [rowNumber]=1
                   [oddNumber]="3"
                   [matchID]="fixtureItem.MatchId"
                   [specialValShow]="false"
                   [fixtureItem]="fixtureItem"
                   [hidingOfFirst]="oddTypeList[0] === this._oddConstant.DECREASED_ITEM_NUM_BY_SPORT[this.sportEnum][0]"
                   [isEmptyType]="this._oddConstant.ODD_TYPE_DROPDOWN[this._uiHelper.oddType_PRE[0]].isEmptyType"

          >
          </oddView>
          <oddView [typeOfList]=typeOfList
                   [_data]="oddValues[1]"
                   [rowNumber]=2
                   [oddNumber]="2"
                   [matchID]="fixtureItem.MatchId"
                   [fixtureItem]="fixtureItem"
                   [isEmptyType]="this._oddConstant.ODD_TYPE_DROPDOWN[this._uiHelper.oddType_PRE[1]].isEmptyType"
          >
          </oddView>
          <oddView [typeOfList]=typeOfList
                   [_data]="oddValues[2]"
                   [rowNumber]=3
                   [oddNumber]="3"
                   [matchID]="fixtureItem.MatchId"
                   [fixtureItem]="fixtureItem"
                   [hidingOfThird]="oddTypeList[2] === this._oddConstant.DECREASED_ITEM_NUM_BY_SPORT[this.sportEnum][1]"
                   [isEmptyType]="this._oddConstant.ODD_TYPE_DROPDOWN[this._uiHelper.oddType_PRE[2]].isEmptyType"

          >
          </oddView>

        </div>
      </div>

      <!--<div class="oddGroup" *ngIf="liveActionView(fixtureItem, isScoreBox)">
        <div class="liveActionView color_{{getLiveActionColorImage(fixtureItem?.BetReasonId).color}}">
          <div class="LiveAnimation">
            <p [inlineSVG]="'/Images/bet-reason/'+ getLiveActionColorImage(fixtureItem?.BetReasonId).image  + '.svg'"
               style="vertical-align: middle;height:38px;"></p>
            <span
              class="cardRightText">{{getLiveActionText(fixtureItem?.BetReason)}}</span>
          </div>
        </div>
      </div>-->
    </div>
    <div class="secondRow secondRowComponent"
         [fixtureItem]="fixtureItem"
         [indexOfItem]="indexOfItem"
         [typeOfList]="typeOfList"
         [oddValues]="oddValues2nd"
         [hidingOfFirst]="oddTypeList[0] === this._oddConstant.DECREASED_ITEM_NUM_BY_SPORT[this.sportEnum][0]"
         [hidingOfThird]="oddTypeList[2] === this._oddConstant.DECREASED_ITEM_NUM_BY_SPORT[this.sportEnum][1]"
         *ngIf="typeOfList === 'live' && fixtureItem.TimeStatu < 3 && !isScoreBox && (this.sportEnum != 2 && this.sportEnum != 3 && this.sportEnum != 4 && this.sportEnum != 5) ">
    </div>
  </div>

  <div class="expandButton">
    <div class="oddGroup">
      <div class="oddContanier">
        <div class="oddItem yellow" (click)="expandNotifierHandler()">
          {{isExpandShow === true ? '-' : '+'}}{{fixtureItem?.OddTypeCount || fixtureItem?.ExtraOddCount}}
        </div>
      </div>
    </div>
  </div>
</div>
<div class="expandContainerParent {{typeOfList}} color_{{IndexOdd}}" [style.display]="isExpandShow ? 'block' : 'none' ">
  <expandView
    [isShow]="isExpandShow"
    [matchId]=fixtureItem.MatchId
    [typeOfList]="typeOfList"
    [fixtureItem]="fixtureItem"></expandView>
</div>
